import React, {useCallback, useEffect, useState} from "react";
import {connect} from "react-redux";
import {deleteZone, getZones,getZonesExcel} from "../ZoneAction";
import Pagination from "@material-ui/lab/Pagination";
import Button from "@material-ui/core/Button";
import {Icon} from "../../../comun/Icon/Icon";
import Divider from "@material-ui/core/Divider";
import {openDialogAction} from "../../../comun/DialogManager/DialogManagerAction";
import {CreateZone} from "../CreateZone/CreateZone";
import {Grid} from "../../../comun/Grid/Grid";
import "./ZoneList.scss";
import {List, ListActions, ListAvatar, ListContent} from "../../../comun/List/List";
import Avatar from "@material-ui/core/Avatar";
import {StandList} from "../../Stand/StandList/StandList";
import HasRole from "../../../../auth/components/HasRole/HasRole";
import {ZoneFilters} from "../ZoneFilter/ZoneFilter";
import TouchRipple from "@material-ui/core/ButtonBase/TouchRipple";
import {getStands} from "../../Stand/StandAction";


export let ZoneList = ({onLoadZone, onDeleteZone, dialogData, onDialogOpen, assignData, action, loadFilter= {}, title ='', ...props}) => {

    const getInitialFilter = () => {
        let res = {page: 0, size: 10};
        if (dialogData !== undefined) {
            res = Object.assign(dialogData, res);

            if (dialogData.action) {
                action = dialogData.action;
            }
            if (dialogData.title) {
                title = dialogData.title;
            }
        }

        return res;
    }
    const [zones, setZones] = useState({content: [], totalPages: 0});
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState(getInitialFilter());
    const[remove,setRemove] = useState(false);

    const handleFilters = (vals) => {
        let data = Object.assign({}, vals);
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                data[key] = (data[key] === '') ? null : data[key];
            }
        }
        data = changeFilter(data);
        data.page = 0;
        setPage(1);
        setFilter(data);
    }

    const changeFilter = useCallback((data) => {
        return Object.assign({}, filter, data);
    }, []);
    
    const changPage = (event, page) => {
        setPage(page);
        const newFilter = { ...filter, page: page - 1 };
        setFilter(newFilter);
        load(newFilter);
    }

    const load = async (filter) => {
        const data = Object.assign(loadFilter, filter);
        await props.onDispatchAction(action, data).then(res => {
            setZones(res);
        })
    }
    
    useEffect(() => {
       load(filter);

       return () => setRemove(false);
    }, [filter,remove]);


    const createZone = () => {
        onDialogOpen({component: CreateZone, data: {editting: false}, opened: true, id: "create-zone-dialog", onClose: () => {
            load(filter);
        }});
    };
    const editZone = (zone) => {
        onDialogOpen({component: CreateZone,  data: {editting: true, id: zone, ...zone}, opened: true, id: "create-zone-dialog", onClose: () => {
            load(filter);
        }});
    };
    const openStands = (zone) => {
        onDialogOpen({component: StandList,  data: {editting: false, zone: zone.id, action: getStands}, opened: true, id: "list-stands-dialog", onClose: () => {
            load(filter);
        }});
    }
    return (
        <div className="box">
            <h1>{title}</h1>

            <Grid columns="5fr 3fr" mobileColumns="1fr">
                <div>
                    <ZoneFilters onSubmit={handleFilters} />
                </div>
                <Pagination count={zones.totalPages} variant="outlined" page={page} shape="rounded" onChange={changPage}/>
            </Grid>

            <HasRole role="AREA_COORDINATOR,FL_MANAGER,ADMIN">
            <Button variant="contained" color="secondary" style={{margin: "7px"}} onClick={createZone}>Añadir Zona</Button>
            <Button variant="contained" color="primary" style={{margin: "7px"}} onClick={getZonesExcel}>Descargar Zonas</Button>
            <br></br>
            <br></br>
            </HasRole>


            {(zones.content.length === 0) ? <p>No hay ninguna zona para mostrar</p> : null}
                {zones.content.map((zone) => {
                    return (
                        <React.Fragment key={zone.id}>
                        <List>
                        <TouchRipple/>
                            <ListAvatar>
                                <Avatar className="list-avatar-container">
                                    <Icon style={{fontSize: "1.6em", color: '#666'}}>add_business</Icon>
                                </Avatar>
                            </ListAvatar>
                            <ListContent>
                                <br></br>
                                <br></br>
                                <h3>{zone.name}</h3>
                            </ListContent>
                        <ListActions>
                            <HasRole role="AREA_COORDINATOR,FL_MANAGER,ADMIN">
                            <div>
                                <Button onClick={() => {
                                    editZone(zone);
                                }}>
                                    <Icon>edit</Icon> EDITAR
                                </Button>
                            </div>
                            </HasRole>
                            <div>
                                <Button onClick={() => {
                                    openStands(zone);
                                 }}>
                                    <Icon>add_business</Icon> STANDS
                                </Button>
                            </div>
                            <HasRole role="AREA_COORDINATOR,FL_MANAGER,ADMIN">
                            <div>
                                <Button onClick={async () => {
                                    await onDeleteZone(zone.id);
                                    setRemove(true);
                                }}>
                                    <Icon>delete</Icon> BORRAR
                                </Button>
                            </div>
                            </HasRole>
                        </ListActions>
                      </List>
                    <Divider />
                        </React.Fragment>
                    )
                })}
        </div>
    )
}

const mapDispatchToProps = dispatch => {
    return {

        onDialogOpen: data => {
            dispatch(openDialogAction(data));
        },
        onDispatchAction: async (action, data) => {
            return await action(data)(dispatch);
        },
        onDeleteZone: async data => {
            return await deleteZone(data)(dispatch);
        }
    }
}
const mapPropsToState = state => {
    return {
        zones: state.zone,
    }
}

ZoneList = connect(mapPropsToState, mapDispatchToProps)(ZoneList);
